import React, { FC, useMemo } from 'react';
import classNames from 'classnames';
import styles from './ResearchCooperation.module.scss';
import { PatentYearItem } from '../type';

interface Props {
  /** 年度专利授权数量数据 */
  dataArr: PatentYearItem[];
  /** 图表底部说明文案 */
  desc: string;
}

/**
 * 专利授权数量柱状图组件
 * 根据年度数据动态计算柱子高度占比，展示历年累计专利授权数量趋势
 */
const PatentBarChart: FC<Props> = (props) => {
  const { dataArr, desc } = props;

  // 以数据中的最大值作为基准，计算每根柱子的高度百分比
  const maxValue = useMemo(() => Math.max(...dataArr.map((item) => item.value), 1), [dataArr]);

  return (
    <div className={styles['patent-chart-card']}>
      <div className={styles['patent-chart-wrapper']}>
        <div className={styles['patent-chart-bars']}>
          {dataArr.map((item) => (
            <div key={item.year} className={styles['patent-chart-bar-col']}>
              <div className={styles['patent-chart-bar-track']}>
                <div className={styles['patent-chart-bar']} style={{ height: `${(item.value / maxValue) * 100}%` }}>
                  <div className={classNames('mt-font', styles['patent-chart-value'])}>{item.value}</div>
                </div>
              </div>
              <div className={styles['patent-chart-year']}>{item.year}</div>
            </div>
          ))}
        </div>
        <div className={styles['patent-chart-desc']}>{desc}</div>
      </div>
    </div>
  );
};

PatentBarChart.displayName = 'PatentBarChart';
export default PatentBarChart;
